/* global Modernizr TweenMax */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StageActions from '../../actions/StageActions';

const propTypes = {
    mouseDown: PropTypes.bool.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    setPreviousVolume: PropTypes.func.isRequired,
};

const defaultProps = {

};

const contextTypes = {
    store: PropTypes.object,
    masterVolume: PropTypes.number,
};

class SoundBar extends Component {

    static onPreventStop(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    constructor(props) {
        super(props);

        this.bar = null;
        this.volumeIcon = null;

        this.onStart = this.onStart.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onEnd = this.onEnd.bind(this);

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.onPlus = this.onPlus.bind(this);
        this.onMinus = this.onMinus.bind(this);

        this.state = {
            x: 0,
            up: false,
            pct: 0.5,

            down: false,
            changed: false,
        };
    }

    componentDidMount() {
        this.resize();
    }

    componentDidUpdate(prevProps, prevState) {
        const xChanged = prevState.x !== this.state.x;

        const widthChanged = prevProps.width !== this.props.width;
        const heightChanged = prevProps.height !== this.props.height;

        const downFinished = prevState.down !== this.state.down && this.state.down === false;
        const changed = prevState.changed !== this.state.changed;

        if (xChanged) {
            TweenMax.to(this.volumeIcon, 0.1, {
                x: this.state.x,
            });
        }

        if (downFinished || changed) {
            // console.log('pct', this.state.pct);
            this.context.store.dispatch(new StageActions.setMasterVolume(this.state.pct / 100));
            this.props.setPreviousVolume(this.state.pct / 100);
        }

        if (widthChanged || heightChanged) {
            this.resize();
        }
    }

    onStart(e) {
        const current = this.getX(e.clientX);
        this.setState({
            ...current,
            down: true,
        });
    }

    onMove(e) {
        if (this.props.mouseDown === true) {
            const current = this.getX(e.clientX);
            this.setState({
                ...current,
                down: true,
            });
        }
    }

    onEnd(e) {
        const current = this.getX(e.clientX);
        this.setState({
            ...current,
            down: false,
        });
    }

    onTouchStart(e) {
        if (!e.changedTouches[0]) return;

        const current = this.getX(e.changedTouches[0].clientX);
        this.setState({
            ...current,
            down: true,
        });
    }

    onTouchMove(e) {
        if (!e.changedTouches[0]) return;

        const current = this.getX(e.changedTouches[0].clientX);
        this.setState({
            ...current,
            down: true,
        });
    }

    onTouchEnd(e) {
        if (!e.changedTouches[0]) return;

        const current = this.getX(e.changedTouches[0].clientX);
        this.setState({
            ...current,
            down: false,
        });
    }

    onPlus() {
        const { x, max, width, changed } = this.state;
        const diff = (width / 10);
        const newX = Math.min(x + diff, width);
        const pct = Math.round((newX / max) * 100);
        this.setState({
            x: newX,
            pct,
            changed: !changed,
        });
    }

    onMinus() {
        const { x, max, width, changed } = this.state;
        const diff = (width / 10);
        const newX = Math.max(x - diff, 0);
        const pct = Math.round((newX / max) * 100);
        this.setState({
            x: newX,
            pct,
            changed: !changed,
        });
    }

    getX(positionX) {
        if (!positionX) return;

        const { min, max } = this.state;
        let x = positionX - this.state.offset;

        if (x >= max) {
            x = max;
        } else if (x <= min) {
            x = min;
        }

        return {
            x,
            pct: Math.round((x / max) * 100),
        };
    }

    resize() {
        const box = this.bar.getBoundingClientRect();
        const icon = this.volumeIcon.getBoundingClientRect();

        // console.log();
        this.setState({
            width: box.width,
            offset: (this.props.width - box.width) / 2, // box.x,
            iconOffset: (icon.width / 2),
            min: 0,
            max: box.width,
            x: Math.floor(this.context.masterVolume * box.width),
        });
    }

    render() {
        const { masterVolume } = this.context;
        const userEvents = {};

        if (Modernizr.touchevents) {
            userEvents.onTouchStart = this.onTouchStart;
            userEvents.onTouchMove = this.onTouchMove;
            userEvents.onTouchEnd = this.onTouchEnd;
        } else {
            userEvents.onMouseDown = this.onStart;
            userEvents.onMouseMove = this.onMove;
            userEvents.onMouseUp = this.onEnd;
            userEvents.onWheel = SoundBar.onPreventStop;
        }

        const className = classNames({
            'volume-icon': true,
            off: masterVolume === 0,
        });

        return (
            <div className="soundbar">
                <button className="plus" type="button" onClick={this.onPlus} />
                <div className="bar" {...userEvents} ref={(el) => { this.bar = el; }}>
                    <div className={className} ref={(el) => { this.volumeIcon = el; }} />
                </div>
                <button className="minus" type="button" onClick={this.onMinus} />
            </div>
        );
    }
}

SoundBar.propTypes = propTypes;
SoundBar.defaultProps = defaultProps;
SoundBar.contextTypes = contextTypes;

module.exports = SoundBar;



// WEBPACK FOOTER //
// ./js/components/partials/SoundBar.jsx